import styled, { keyframes, css } from "styled-components";

// === CHARGING/PULSING ANIMACIJA - NORMALNA ===
const chargePulse = keyframes`
  0%, 100% { 
    transform: scale(1);
    box-shadow: 
      0 0 0 0 rgba(63, 136, 247, 0.4),
      inset 0 0 10px rgba(63, 136, 247, 0.2);
  }
  50% { 
    transform: scale(0.95);
    box-shadow: 
      0 0 20px 5px rgba(63, 136, 247, 0.6),
      inset 0 0 20px rgba(63, 136, 247, 0.4);
  }
`;

// === CHARGING/PULSING ANIMACIJA - SUBTLE ===
const chargePulseSubtle = keyframes`
  0%, 100% { 
    transform: scale(1);
    box-shadow: 
      0 0 0 0 rgba(63, 136, 247, 0.2),
      inset 0 0 5px rgba(63, 136, 247, 0.1);
  }
  50% { 
    transform: scale(0.97);
    box-shadow: 
      0 0 10px 2px rgba(63, 136, 247, 0.4),
      inset 0 0 10px rgba(63, 136, 247, 0.2);
  }
`;

// Glow NORMALNI
const glowPulse = keyframes`
  0%, 100% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(0.95);
  }
`;

// Glow SUBTLE
const glowPulseSubtle = keyframes`
  0%, 100% {
    opacity: 0.25;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(0.98);
  }
`;

// Shimmer efekat
const shimmer = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

// === EKSPLOZIJA ANIMACIJA - NORMALNA ===
const explode = keyframes`
  0% {
    transform: scale(0.92);
    box-shadow: 
      0 0 20px 5px rgba(63, 136, 247, 0.6),
      inset 0 0 20px rgba(63, 136, 247, 0.4);
  }
  30% {
    transform: scale(1.15);
    box-shadow: 
      0 0 40px 15px rgba(63, 136, 247, 0.8),
      0 0 60px 25px rgba(45, 120, 255, 0.5),
      inset 0 0 30px rgba(255, 255, 255, 0.3);
  }
  50% {
    transform: scale(1.08);
  }
  70% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
    box-shadow: none;
  }
`;

// === EKSPLOZIJA ANIMACIJA - SUBTLE ===
const explodeSubtle = keyframes`
  0% {
    transform: scale(0.97);
    box-shadow: 
      0 0 10px 2px rgba(63, 136, 247, 0.3),
      inset 0 0 10px rgba(63, 136, 247, 0.2);
  }
  30% {
    transform: scale(1.05);
    box-shadow: 
      0 0 15px 5px rgba(63, 136, 247, 0.4),
      0 0 25px 10px rgba(45, 120, 255, 0.2),
      inset 0 0 15px rgba(255, 255, 255, 0.15);
  }
  50% {
    transform: scale(1.03);
  }
  70% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
    box-shadow: none;
  }
`;

// Ring eksplozija - NORMALNA
const ringExpand = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 1;
    border-width: 4px;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
    border-width: 1px;
  }
`;

// Ring eksplozija - SUBTLE
const ringExpandSubtle = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.6;
    border-width: 2px;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
    border-width: 1px;
  }
`;

// Drugi prsten - NORMALNI
const ringExpand2 = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0.8;
    border-width: 3px;
  }
  100% {
    transform: translate(-50%, -50%) scale(2);
    opacity: 0;
    border-width: 1px;
  }
`;

// Drugi prsten - SUBTLE
const ringExpand2Subtle = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.4;
    border-width: 2px;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.4);
    opacity: 0;
    border-width: 1px;
  }
`;

// Particle eksplozija - NORMALNA
const particleExplode = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(3);
    opacity: 0;
  }
`;

// Particle eksplozija - SUBTLE
const particleExplodeSubtle = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0.5;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
`;

// Wrapper za dugme sa efektima eksplozije
export const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 100px;
    background: radial-gradient(
      circle,
      rgba(63, 136, 247, ${(props) => (props.$subtle ? "0.2" : "0.4")}) 0%,
      transparent 70%
    );
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }

  ${(props) =>
    props.$isLoading &&
    css`
      &::before {
        opacity: 1;
        animation: ${props.$subtle ? glowPulseSubtle : glowPulse}
          ${props.$subtle ? "1.2s" : "0.8s"} ease-in-out infinite;
      }
    `}

  ${(props) =>
    props.$isExploding &&
    css`
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        border-radius: 100px;
        border: ${props.$subtle ? "2px" : "4px"} solid
          rgba(63, 136, 247, ${props.$subtle ? "0.5" : "0.8"});
        background: transparent;
        animation: ${props.$subtle ? ringExpandSubtle : ringExpand} 0.6s
          ease-out forwards;
        pointer-events: none;
      }
    `}
`;

// Dodatni prsten za eksploziju
export const ExplosionRing = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  border: ${(props) => (props.$subtle ? "2px" : "3px")} solid
    rgba(123, 180, 255, ${(props) => (props.$subtle ? "0.3" : "0.6")});
  background: transparent;
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
  pointer-events: none;

  ${(props) =>
    props.$isExploding &&
    css`
      animation: ${props.$subtle ? ringExpand2Subtle : ringExpand2} 0.5s
        ease-out 0.1s forwards;
    `}
`;

// Particle burst efekat
export const ParticleBurst = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${(props) => (props.$subtle ? "120%" : "150%")};
  height: ${(props) => (props.$subtle ? "120%" : "150%")};
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(63, 136, 247, ${(props) => (props.$subtle ? "0.15" : "0.3")}) 0%,
    transparent 60%
  );
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
  pointer-events: none;

  ${(props) =>
    props.$isExploding &&
    css`
      animation: ${props.$subtle ? particleExplodeSubtle : particleExplode} 0.5s
        ease-out forwards;
    `}
`;

export const Button = styled.button`
  display: flex;
  height: ${(p) => (p.$small ? "40px" : "44px")};
  width: 100%;
  padding: 12px 24px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 100px;
  background: #fff;
  border: 2px solid transparent;
  outline: none;
  color: #0f2c32;
  font-family: Figtree;
  font-size: ${(p) => (p.$small ? "14px" : "16px")};
  font-weight: 600;
  letter-spacing: -0.08px;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease,
    opacity 0.3s ease,
    border 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;

  &:hover:not(:disabled) {
    background: #f5f5f5;
  }

  &:disabled {
    cursor: not-allowed;
  }

  /* === LOADING/CHARGING STATE === */
  ${(props) =>
    props.$isLoading &&
    css`
      background: linear-gradient(
        135deg,
        #ffffff 0%,
        #e8f0fe 50%,
        #ffffff 100%
      );
      border: 2px solid rgba(63, 136, 247, 0.5);
      animation: ${props.$subtle ? chargePulseSubtle : chargePulse}
        ${props.$subtle ? "1.2s" : "0.8s"} ease-in-out infinite;

      /* Shimmer overlay */
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(63, 136, 247, 0.15) 25%,
          rgba(123, 180, 255, 0.25) 50%,
          rgba(63, 136, 247, 0.15) 75%,
          transparent 100%
        );
        background-size: 200% 100%;
        animation: ${shimmer} ${props.$subtle ? "1.8s" : "1.2s"} linear infinite;
        border-radius: 100px;
      }
    `}

  /* === EXPLODING STATE === */
  ${(props) =>
    props.$isExploding &&
    css`
      animation: ${props.$subtle ? explodeSubtle : explode} 0.5s ease-out
        forwards;
      border: 2px solid rgba(63, 136, 247, ${props.$subtle ? "0.5" : "0.8"});

      &::before {
        display: none;
      }
    `}
`;
